export const FETCH_PROFILE_COMPLETION_REQUEST = 'FETCH_PROFILE_COMPLETION_REQUEST';
export const FETCH_PROFILE_COMPLETION_SUCCESS = 'FETCH_PROFILE_COMPLETION_SUCCESS';
export const FETCH_PROFILE_COMPLETION_FAILURE = 'FETCH_PROFILE_COMPLETION_FAILURE';
